import { IFormRegister } from 'routes/Main/type';

import Form from 'components/Form';
import RowContainer from '../../components/RowContainer';
import RowContent from '../../components/RowContent';
import SectionTitle from '../../components/SectionTitle';

import { Box, Table, TableBody, TableRow } from '@mui/material';

import {
  StyledTableCell,
  StyledTableCellWithoutLeft,
  StyledTableCellWithoutLeftRight,
} from 'routes/Main/style';

interface Props extends IFormRegister {
  disabled?: boolean;
}

const Signature = (props: Props) => {
  const { disabled, register } = props;

  return (
    <>
      <Box sx={{ width: '1200px', margin: '10px auto' }}>
        <Table aria-label="simple table">
          <TableBody>
            <TableRow>
              <StyledTableCell
                align="center"
                sx={{
                  padding: '50px',
                  width: '200px',
                  fontSize: '12px',
                  fontWeight: 500,
                }}
              >
                Bệnh nhân
              </StyledTableCell>
              <StyledTableCellWithoutLeftRight>
                <div style={{ display: 'flex', margin: '20px 0 20px 0' }}>
                  <Box
                    sx={{
                      paddingTop: '10px',
                      paddingLeft: '10px',
                      minWidth: '200px',
                      fontSize: '12px',
                      fontWeight: 500,
                    }}
                  >
                    Ngày sinh
                  </Box>
                  <Form.MuiTextField
                    required={false}
                    disabled={disabled}
                    {...register('pt_bday')}
                  />
                  <Box
                    sx={{
                      paddingTop: '10px',
                      paddingLeft: '10px',
                      minWidth: '200px',
                      fontSize: '12px',
                      fontWeight: 500,
                    }}
                  >
                    Số điện thoại
                  </Box>
                  <Form.MuiTextField
                    sx={{ paddingRight: '10px' }}
                    required={false}
                    disabled={disabled}
                    {...register('pt_contact')}
                  />
                </div>
                <div style={{ display: 'flex', marginBottom: '20px' }}>
                  <Box
                    sx={{
                      paddingTop: '10px',
                      paddingLeft: '10px',
                      minWidth: '200px',
                      fontSize: '12px',
                      fontWeight: 500,
                    }}
                  >
                    Tên
                  </Box>
                  <Form.MuiTextField
                    required={false}
                    disabled={disabled}
                    {...register('pt_name')}
                  />
                  <Box
                    sx={{
                      paddingTop: '10px',
                      paddingLeft: '10px',
                      minWidth: '200px',
                      fontSize: '12px',
                      fontWeight: 500,
                    }}
                  >
                    Signature
                  </Box>
                  <Form.MuiTextField
                    required={false}
                    sx={{ paddingRight: '10px' }}
                    disabled={disabled}
                    {...register('pt_sign')}
                  />
                </div>
              </StyledTableCellWithoutLeftRight>
              <StyledTableCellWithoutLeft></StyledTableCellWithoutLeft>
            </TableRow>

            <TableRow>
              <StyledTableCell
                align="center"
                sx={{
                  padding: '50px',
                  width: '200px',
                  fontSize: '12px',
                  fontWeight: 500,
                }}
              >
                Người giám hộ
              </StyledTableCell>
              <StyledTableCellWithoutLeftRight>
                <div style={{ display: 'flex', margin: '20px 0 20px 0' }}>
                  <Box
                    sx={{
                      paddingTop: '10px',
                      paddingLeft: '10px',
                      minWidth: '200px',
                      whiteSpace: 'nowrap',
                      fontSize: '12px',
                      fontWeight: 500,
                    }}
                  >
                    Quan hệ với bệnh nhân
                  </Box>
                  <Form.MuiTextField
                    required={false}
                    disabled={disabled}
                    {...register('nok_bday')}
                  />
                  <Box
                    sx={{
                      paddingTop: '10px',
                      paddingLeft: '10px',
                      minWidth: '200px',
                      fontSize: '12px',
                      fontWeight: 500,
                    }}
                  >
                    Số điện thoại
                  </Box>
                  <Form.MuiTextField
                    sx={{ paddingRight: '10px' }}
                    required={false}
                    disabled={disabled}
                    {...register('nok_contact')}
                  />
                </div>
                <div style={{ display: 'flex', marginBottom: '20px' }}>
                  <Box
                    sx={{
                      paddingTop: '10px',
                      paddingLeft: '10px',
                      minWidth: '200px',
                      fontSize: '12px',
                      fontWeight: 500,
                    }}
                  >
                    Tên
                  </Box>
                  <Form.MuiTextField
                    required={false}
                    disabled={disabled}
                    {...register('nok_name')}
                  />
                  <Box
                    sx={{
                      paddingTop: '10px',
                      paddingLeft: '10px',
                      minWidth: '200px',
                      fontSize: '12px',
                      fontWeight: 500,
                    }}
                  >
                    Chữ ký
                  </Box>
                  <Form.MuiTextField
                    sx={{ paddingRight: '10px' }}
                    required={false}
                    disabled={disabled}
                    {...register('nok_sign')}
                  />
                </div>
              </StyledTableCellWithoutLeftRight>
              <StyledTableCellWithoutLeft></StyledTableCellWithoutLeft>
            </TableRow>

            <TableRow>
              <StyledTableCell
                align="center"
                sx={{
                  padding: '30px',
                  width: '200px',
                  fontSize: '12px',
                  fontWeight: 500,
                }}
              >
                Bác sĩ
              </StyledTableCell>
              <StyledTableCellWithoutLeftRight>
                <div style={{ display: 'flex', margin: '20px 0 20px 0' }}>
                  <Box
                    sx={{
                      paddingTop: '10px',
                      paddingLeft: '10px',
                      minWidth: '200px',
                      fontSize: '12px',
                      fontWeight: 500,
                    }}
                  >
                    Tên
                  </Box>
                  <Form.MuiTextField
                    required={false}
                    disabled={disabled}
                    {...register('dr_name')}
                  />
                  <Box
                    sx={{
                      paddingTop: '10px',
                      paddingLeft: '10px',
                      minWidth: '200px',
                      fontSize: '12px',
                      fontWeight: 500,
                    }}
                  >
                    Chữ ký
                  </Box>
                  <Form.MuiTextField
                    sx={{ paddingRight: '10px' }}
                    required={false}
                    disabled={disabled}
                    {...register('dr_sign')}
                  />
                </div>
              </StyledTableCellWithoutLeftRight>
              <StyledTableCellWithoutLeft></StyledTableCellWithoutLeft>
            </TableRow>
          </TableBody>
        </Table>
      </Box>
    </>
  );
};

export default Signature;
